import { Box, Typography } from "@mui/material";
import React from "react";

export default function ProductCartItem({ data = {} }) {
  const { image, name, price } = { ...data };
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      marginTop={1}
    >
      <Typography variant="h6">Your Order</Typography>
      <Box
        display="flex"
        mt={3}
        padding={3}
        gap={3}
        borderRadius={1}
        style={{ backgroundColor: "#191922" }}
      >
        <img src={image} width={118} height={90} alt="payment-product" />
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="body2" fontWeight={600} fontSize={16}>
            {name}
          </Typography>
          <Typography variant="body2" color="#FFC831" fontWeight={600}>
            {price}$
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
